const ACCOUNT = Object.freeze({
	LOGIN_SSO: 'LOGIN_SSO',
	LOGIN: 'LOGIN',
	LOGOUT: 'LOGOUT',
	RSET_PSWD: 'RESET_PASSWORD',
	COMPEL_CHANGE_PSWD: 'COMPEL_CHANGE_PASSWORD',
	GET: 'GET_ACCOUNT',
	SET: 'SET_ACCOUNT',
	UPDATE: 'UPDATE_ACCOUNT',
	CURRENT: 'GET_CURRENT_ACCOUNT',
	GET_SUCH_ACCOUNT: 'GET_ONE_ACCUONT_ONFO',
	GET_MFA_SECRET: 'GET_MFA_SECRET',
	POST_MFA_CODE: 'POST_MFA_CODE',
	VERIFY_MFA_CODE: 'VERIFY_MFA_CODE',
	CODE: 'GET_CODE',
	VERIFY: 'VERIFY_MOBILE',
	FORGRTPASSWORD: 'FORGOT_PASSWORD',
	CAANGE_AVATAR: 'CHANGE_CURRENT_ACCOUNT_AVATAR',
	SHOW_CAPTCHA: 'SHOW_CAPTCHA',
	NOTIFY_BANNER: 'NOTIFY_BANNER',
	CHECK_SSO: 'CHECK_SSO',
})

const SSHKEY = Object.freeze({
	GET: 'GET_LIST',
	ADD: 'ADD_LIST',
	DEL: 'DEL_LIST',
	UPDATE: 'UPDATE_LIST',
})

const TEAM = Object.freeze({
	CURRENT: 'GET_CURRENT_COMPANY',
	LIST: 'GET_TEAM_LIST',
	GET_MEMBER_LIST: 'GET_TEAM_MEMBER_LIST',
	ADD: 'ADD_TEAM_MEMBER',
	UPDATE: 'UPDATE_TEAM_LIST',
	SET: 'SET_CURRENT_TEAM_INDO',
	DELETE: 'DELETE_TEAM_MEMBER',
	GET_MEMBER: 'GET_TEAM_MEMBER_INFO',
	EDIT_MEMBER: 'EDIT_TEAM_MEMBER_INFO',
	GROUP_LIST: 'GET_TEAM_GROUP_LIST',
	ADD_GROUP: 'ADD_TEAM_GROUP',
	EDIT_GROUP: 'EDIT_TEAM_GROUP_INFO',
	DELETE_GROUP: 'DELETE_TEAM_GROUP',
	GET_GROUP: 'GET_TEAM_GROUP_INFO',
	GET_GROUP_MEMBERS: 'GET_TEAM_GROUP_MEMBER_LIST',
	GROUP_ADD_MEMBER: 'TEAM_GROUP_ADD_MEMBER',
	DEL_GROUP_MEMBER: 'DELETE_TEAM_GROUP_MEMBER',
	GET_STATISTIC_TEAM: 'GET_STATISTIC_TEAM',
	GET_RESOURCE_STATISTIC_TEAM: 'GET_RESOURCE_STATISTIC_TEAM',
	GET_PLAN: 'GET_PLAN_INFO',
	UPDATE_TEAM_TOKEN: 'UPDATE_TEAM_TOKEN',
	UNBIND_WORKSPACE: 'UNBIND_WORKSPACE',
	RESET_MFA: 'RESET_MFA',
	GET_SSO_CONFIG: 'GET_SSO_CONFIG',
	UPDATE_SSO_CONFIG: 'UPDATE_SSO_CONFIG',
	GET_NTP_CONFIG: 'GET_NTP_CONFIG',
	UPDATE_NTP_CONFIG: 'UPDATE_NTP_CONFIG',
})

const LOG = Object.freeze({
	LOGIN: 'LOGIN_LOGS',
	TEAM: 'TEAM_LOGS',
	UNFREEZE: 'UNFREEZE',
	VIEW_LOG: 'VIEW_LOG',
	CLUSTER: 'CLUSTER_LOGS',
	RESOURCE: 'RESOURCE_LOGS',
	ALARM: 'ALARM',
	HANDLE_NOTICE: 'HANDLE_NOTICE',
	ACTION: 'ACTION_LOGS',
	GET_ACCOUNT_NAME: 'GET_ALL_ACCOUNT_NAME',
	GET_RESOURCE_NAME: 'GET_ALL_RESURCE_NAME',
	GET_ALARM_NOTIFY_UNREAD_COUNTS: 'GET_ALARM_NOTIFY_UNREAD_COUNTS',
	CLOSE_ALARM_NOTIFY: 'CLOSE_ALARM_NOTIFY',
	UNREAD_COUNTS: 'UNREAD_COUNTS',
})

const CLUSTER = Object.freeze({
	GET: 'GET_CLUSTER_LIST',
	GET_CLUSTER: 'GET_CLUSTER',
	ADD: 'ADD_CLUSTER',
	DELETE: 'DELETE_CLUSTER',
	CHANGE: 'CHANGE_CLUSTER_INFO',
	GET_DETAIL: 'GET_CLUSTER_DETAIL',
	DETAIL_LIST: 'GET_CLUSTER_DETAIL_LIST',
	GET_CLUSTER_RESOURCE: 'GET_CLUSTER_RESOURCE',
	DELETE_RESOURCE: 'DELETE_DETAIL_RESOURCE',
	BATCH_DELETE_RESOURCE: 'BATCH_DELETE_RESURCE',
	ADD_RESOURCE: 'ADD_CLUSTER_RESOURCE',
	PATCH_RESOURCE: 'PATCH_RESOURCE_DETAIL',
	GET_RESOURCE_DETAIL: 'GET_RESOURCE_DETAIL',
	GET_INTERCEPTS_COMMADN: 'GET_INTERCEPTS_COMMADN',
	ADD_LOG_FILTER: 'ADD_LOG_FILTER',
	DEL_LOG_FILTER: 'DEL_LOG_FILTER',
	DEL_BARCH_LOG_FILTER: 'DEL_BATCH_LOG_FILTER',
	UPDATE_DETAIL: 'UPDATE_DETAIL_RESOURCE_INFO',
	CHECK_AGENT: 'CHECK_AGENT_NEW_VERSION',
	GET_SHARING: 'GET_SHARING_CLUSTER_LIST',
	ADD_SHARING: 'ADD_SHARING_CLUSTER',
	CANCEL_SHARE: 'CANCEL_SHARING_CLUSTER',
	GET_SAFE_APPROVER: 'GET_SAFE_APPROVER',
	ADD_INTERCEPT: 'ADD_NEED_INTERCEPT_COMMAND',
	DEL_INTERCEPT: 'DEL_NEED_INTERCEPT_COMMAND',
	DEL_ALARM_INTERCEPT: 'DEL_NEED_INTERCEPT_COMMAND_ALARM',
	SCAN_SATRT: 'SCAN_IMPORT_START',
	SCAN_QUERY: 'SCAN_IMPORT_QUERY',
	POST_BATCH_RESOURCE: 'SCAN_IMPORT_BATCH_RESOURCE',
	TEST_CONNECTION: 'TEST_CONNECTION',
	QUERY_TEST: 'QUERY_TEST_CONNECTION',
	TEST_KEY_AVALIABLE: 'TEST_KEY_AVALIABLE',
	QUERY_KEY_AVALIABLE: 'QUERY_KEY_AVALIABLE',
	XLSX_BATCH_IMPORT: 'XLSX_BATCH_IMPORT_RESOIRCE',
	GET_CLUSTER_RESOURCE_STATISTIC: 'GET_CLUSTER_RESOURCE_STATISTIC',
	GET_CLUSTER_STATISTIC: 'GET_CLUSTER_STATISTIC',
	GET_RESOURCE_STATISTIC: 'GET_RESOURCE_STATISTIC',
	UOLOAD_SSHKEY: 'HOST_SETTING_UPLOAD_SSHKEY',
	QUERY_SSHKEY: 'QUERY_SSHKEY',
	GET_ALIYUN_ECS: 'GET_ALIYUN_ECS',
	SCAN_NEW_QUERY: 'SCAN_NEW_QUERY',
	BAECH_DELETE_ONLINE_USER: 'BAECH_DELETE_ONLINE_USER',
	AGENT_VERSION: 'AGENT_VERSION',
	CLOUD_IMPORT_ECS: 'CLOUD_IMPORT_ECS',
	CLOUD_IMPORT_RDS: 'CLOUD_IMPORT_RDS',
	CLOUD_GET_REGIONS: 'CLOUD_GET_REGIONS',
	SCAN_INSTANCE: 'SCAN_INSTANCE',
	LOAD_INSTANCE: 'LOAD_INSTANCE',
	GET_RESOURCE_LISTS: 'GET_RESOURCE_LISTS',
	EXPORT_CLUSTER_CONFIG: 'EXPORT_CLUSTER_CONFIG',
	IMPORT_CLUSTER_CONFIG: 'IMPORT_CLUSTER_CONFIG',
	POLLING_CLUSTER_CONFIG: 'POLLING_CLUSTER_CONFIG',
	SET_CONFIG_POLLING_INSTANCE: 'SET_CONFIG_POLLING_INSTANCE',
	CLEAR_CONFIG_POLLING_INSTANCE: 'CLEAR_CONFIG_POLLING_INSTANCE',
})

const DOCUMENT = Object.freeze({
	GET_LIST: 'GET_DOCUMENT_LIST',
	DEL: 'DELETE_DOCUMENT',
	UPLOAD: 'UPLOAD_DOCUMENT',
})

const WORKGROUP = Object.freeze({
	LIST_WORKGROUP: 'LIST_WORKGROUP',
	LIST_FAVOURITE_WORKGROUP: 'LIST_FAVOURITE_WORKGROUP',
	SET_FAVOURITE: 'SET_FAVOURITE',
	GET_WORKGROUP_DETAIL: 'GET_WORKGROUP_DETAIL',
	LIST_WORKGROUP_RESOURCE: 'LIST_WORKGROUP_RESOURCE',
	GET_TUNNEL_CODE: 'GET_TUNNEL_CODE',
	DELETE_WORKGROUP: 'DELETE_WORKGROUP',
	CREATE_CSOS_REPORT: 'CREATE_CSOS_REPORT',
	GET_CSOS_REPORT: 'GET_CSOS_REPORT',
	GET_CSOS_REPORT_STATE: 'GET_CSOS_REPORT_STATE',
	GET_VERSION_BY_TYPE: 'GET_VERSION_BY_TYPE',
	CREATED_WORKGROUP: 'CREATED_WORKGROUP',
	PATCH_WORKGROUP: 'PATCH_WORKGROUP',
	GET_CONNECT_LOG: 'GET_CONNECT_LOG',
	GET_TUNNEL_INFO: 'GET_TUNNEL_INFO',
	TEST_PASSWORD_CONNECTION: 'TEST_PASSWORD_CONNECTION',
	UPDATE_TUNNEL: 'UPDATE_TUNNEL',
	DEL_WORKGROUP_RESOURCE: 'DELETE_WORKGROUP_RESOURCE',
	ADD_WORKGTOUP_RESOURCE: 'ADD_WORKGROUP_RESOURCE',
	GET_MEMBER_LIST: 'GET_WORKGROUP_MEMBER_LIST',
	DEL_MEMBER: 'DEL_WORKGROUP_MEMBER',
	ADD_MEMBER: 'ADD_WORKGTOUP_MEMBER',
	PATCH_MEMBER: 'PATCH_WORKGROUP_MEMBER',
	GET_MEMBER_ADMIN: 'GET_MEMBER_ADMIN',
	GET_PROJECT_RESOURCE_INFO: 'GET_PROJECT_RESOURCE_INFO',
	GET_CLIENT_IP: 'GET_CLIENT_IP',
	CREATE_CODE: 'CREATE_CODE',
	DELETE_CODE: 'DELETE_CODE',
	GET_CODE_INFO: 'GET_CODE_INFO',
	MODIFY_CODE: 'MODIFY_CODE',
	SET_PROJECT_DEFAULT_NAME: 'SET_PROJECT_DEFAULT_NAME',
	GET_CODE_VERSION: 'GET_CODE_VERSION',
	GET_LITE_CONNECT_INFO: 'GET_LITE_CONNECT_INFO',
	GET_WORKGROUP_RESOURCE_ONLINE_CONNECTS: 'GET_RESOURCE_ONLINE_CONNECTS',
	GET_ASSIST_INFO: 'GET_ASSIST_INFO',
	GET_SHADOW_CONNECT: 'GET_SHADOW_CONNECT',
	QUERY_CSOS_CONNECT: 'QUERY_CSOS_CONNECT',
	GET_CSOS_SHADOW: 'GET_CSOS_SHADOW',
	GET_WORKGROUP_GROUP: 'GET_WORKGROUP_GROUP',
	GET_GROUP_LIST: 'GET_WORKGROUP_GROUP_LIST',
	ADD_GROUP: 'ADD_WORKGTOUP_GROUP',
	DEL_GROUP: 'DEL_WORKGROUP_GROUP',
	CHANGE_LOGIN_USER: 'CHANGE_LOGIN_USER',
	VERIFY_SQL: 'VERIFY_SQL',
	GET_ACCOUNT_WORKGROUP_LIST: 'GET_ACCOUNT_WORKGROUP_LIST',
	ADD_ACCOUNT_WORKGROUP: 'ADD_ACCOUNT_WORKGROUP',
	DEL_ACCOUNT_WORKGROUP: 'DEL_ACCOUNT_WORKGROUP',
	GET_WORKGROUP_LIST_BY_GROUP: 'GET_WORKGROUP_LIST_BY_GROUP',
	ADD_GROUP_WORKGROUP: 'ADD_GROUP_WORKGROUP',
	DEL_GROUP_WORKGROUP: 'DEL_GROUP_WORKGROUP',
})

const DASHBOARD = Object.freeze({
	LIST_ONLINE_CONNECT_COUNTS: 'LIST_ONLINE_CONNECT_COUNTS',
	LIST_ONLINE_CONNECT: 'LIST_ONLINE_CONNECT',
	CUT_ONLINE: 'CUE_ONLINE',
	CUT_ONLINE_MULTIPLE: 'CUT_ONLINE_MULTIPLE',
	LIST_WORKGROUP_RESOURCE: 'LIST_DASHBOARD_RESOURCE',
	LIST_TOP_MEMBERS: 'LIST_TOP_MEMBERS',
	LIST_TOP_RESOURCES: 'LIST_TOP_RESOURCES',
	GET_STATISTICS: 'GET_STATISTICS',
	GET_CONNECT_NUMBER: 'GET_CONNECT_NUMBER',
	GET_OPERATION_WEEK: 'GET_OPERATION_WEEK',
	GET_RESOURCE_TYPE_STATISTIC: 'GET_RESOURCE_TYPE_STATISTIC',
	GET_ONLINE_CONNECT: 'GET_ONLINE_CONNECT',
	GET_STATISTIC_SUMMARY: 'GET_STATISTIC_SUMMARY',
})

const REVIEW = Object.freeze({
	GET_PROJECT_LIST: 'GET_PROJECT_LIST',
	GET_RESOURCE_LIST: 'GET_RESOURCE_LIST',
	CREATE_SQL_APPLICATION: 'CREATE_SQL_APPLICATION',
	GET_MY_SQL_APPLICATION: 'GET_MY_SQL_APPLICATION',
	GET_SQL_APPROVING_APPLICATION: 'GET_SQL_APPROVING_APPLICATION',
	GET_SQL_APPROVED_APPLICATION: 'GET_SQL_APPROVED_APPLICATION',
	GET_SAFE_APPLICATION: 'GET_SAFE_APPLICATION',
	CREATE_SAFE_APPLY: 'CREATE_SAFE_APPLY',
	GET_MY_SAFE_APPLY: 'GET_MY_SAFE_APPLY',
	GET_SAFE_APPROVING_APPLY: 'GET_SAFE_APPROVING_APPLY',
	GET_SAFE_APPROVED_APPLY: 'GET_SAFE_APPROVED_APPLY',
	GET_MY_APPLY_DETAIL: 'GET_MY_APPLY_DETAIL',
	DELETE_SQL_APPLY: 'DELETE_SQL_APPLY',
	EXECUTE_SQL_APPLICATION: 'EXECUTE_SQL_APPLICATION',
	REJECT_SQL_APPLICATION: 'REJECT_SQL_APPLICATION',
	GET_SAFE_DETAIL: 'GET_SAFE_DETAIL',
	DELETE_SAFE_APPLY: 'DELETE_SAFE_APPLY',
	DO_SAFE_EXCUTE: 'DO_SAFE_EXCUTE',
	DO_SAFE_REJECT: 'DO_SAFE_REJECT',
	GET_ONLINE_CONNECT: 'GET_ONLINE_CONNECT',
})

export default {
	ACCOUNT,
	TEAM,
	LOG,
	CLUSTER,
	DOCUMENT,
	SSHKEY,
	DASHBOARD,
	REVIEW,
	WORKGROUP,
}



// WEBPACK FOOTER //
// ./src/store/consts.js